import { api } from "@/lib/orgApi";

export const LOINC_SYSTEM = "http://loinc.org";

export async function listLabs({ q, active, category } = {}) {
  const params = {};
  if (q) params.q = q;
  if (active != null) params.active = active;
  if (category) params.category = category;
  const { data } = await api.get("/labs", { params });
  return data;
}

export async function getLab(labId) {
  const { data } = await api.get(`/labs/${encodeURIComponent(labId)}`);
  return data;
}
